import { isNodeV2 } from '@vedalib/editor'
import * as R from 'ramda'

import { getParentNode } from 'components/Editor/EditorContext/selectors/block'
import { updateBlock } from 'services/Store/Project/actions'
import { setFlexShrink } from 'services/Store/Project/mutators/node'
import {
  getBlock,
  getDeviceMode,
  getSelectedNodeIds,
  mergeNodeStyle,
} from 'services/Store/Project/selectors'
import type { Block } from 'services/Store/Project/types'
import store from 'services/Store/store'

import { isFlex } from '../guards'

export const onShrink = async () => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const device = getDeviceMode(state)
  const selectedNodes = getSelectedNodeIds(state)
  const children = selectedNodes.map((id) => block?.schema.nodes[id]).filter(isNodeV2)
  const parent = getParentNode(selectedNodes?.[0], block)
  const parentStyle = mergeNodeStyle(parent?.style || {}, device)

  if (block && isFlex(parentStyle)) {
    const shrink = children.every((node) => mergeNodeStyle(node.style, device).flexShrink === 1)
    const cbs = children.map((node) => setFlexShrink(node.id, device, Number(!shrink)))
    const newBlock = R.compose(...(cbs as [(block: Block) => Block]))(block)
    dispatch(updateBlock({ id: block.uuid, value: newBlock }))
  }
}
